// esbuild uses this script to load browser polyfills.
// See the `build` script in `package.json`.
export { Buffer } from 'buffer'
